module.exports = __webpack_public_path__ + "img/Mom-icons_Dashboard.48cf02de.png";